export default __webpack_public_path__ + "static/media/counterstrike4.a3bdd9b4.png";